import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { EStatus } from '../../repositories/users/v2/register-or-authorize-user/types';
export var ERegisterOrAuthorizeEnhancedStatus = /*#__PURE__*/function (ERegisterOrAuthorizeEnhancedStatus) {
  ERegisterOrAuthorizeEnhancedStatus["Success"] = "success";
  ERegisterOrAuthorizeEnhancedStatus["Wrong"] = "wrong";
  ERegisterOrAuthorizeEnhancedStatus["CheckPassword"] = "checkPassword";
  ERegisterOrAuthorizeEnhancedStatus["CodeInputLimitReached"] = "codeInputLimitReached";
  ERegisterOrAuthorizeEnhancedStatus["CodeExpired"] = "codeExpired";
  ERegisterOrAuthorizeEnhancedStatus["ManyAccounts"] = "manyAccounts";
  ERegisterOrAuthorizeEnhancedStatus["BrokenContract"] = "brokenContract";
  ERegisterOrAuthorizeEnhancedStatus["Error"] = "error";
  return ERegisterOrAuthorizeEnhancedStatus;
}({});
export function getBrokenContractResponse(response) {
  return {
    status: ERegisterOrAuthorizeEnhancedStatus.BrokenContract,
    originalResponse: response
  };
}
export function transform200(response) {
  var status = response.status,
    users = response.users,
    isRegistered = response.isRegistered,
    temporaryToken = response.temporaryToken,
    token = response.token,
    logOnUrl = response.logOnUrl;
  switch (status) {
    case EStatus.Success:
      if (users.length === 0 || !token || !logOnUrl) {
        return getBrokenContractResponse(response);
      }
      return {
        status: ERegisterOrAuthorizeEnhancedStatus.Success,
        email: users[0].email,
        token: token,
        logOnUrl: logOnUrl,
        isRegistered: Boolean(isRegistered)
      };
    case EStatus.ManyAccounts:
      if (!temporaryToken || users.length === 0) {
        return getBrokenContractResponse(response);
      }
      return {
        status: ERegisterOrAuthorizeEnhancedStatus.ManyAccounts,
        accounts: users.map(function (user) {
          return user.email;
        }),
        temporaryToken: temporaryToken
      };
    case EStatus.CodeExpired:
      return {
        status: ERegisterOrAuthorizeEnhancedStatus.CodeExpired
      };
    case EStatus.CheckPassword:
      return {
        status: ERegisterOrAuthorizeEnhancedStatus.CheckPassword
      };
    case EStatus.CodeInputLimitReached:
      return {
        status: ERegisterOrAuthorizeEnhancedStatus.CodeInputLimitReached
      };
    case EStatus.Wrong:
      return {
        status: ERegisterOrAuthorizeEnhancedStatus.Wrong
      };
    default:
      return getBrokenContractResponse(response);
  }
}
export function transform400(response) {
  return _objectSpread({
    status: ERegisterOrAuthorizeEnhancedStatus.Error
  }, response);
}